import { render, staticRenderFns } from "./emptyData.vue?vue&type=template&id=1a62c9a3"
import script from "./emptyData.vue?vue&type=script&lang=js"
export * from "./emptyData.vue?vue&type=script&lang=js"
import style0 from "./emptyData.vue?vue&type=style&index=0&id=1a62c9a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports